import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { FF_NAME_ON_DEMAND_MODE } from 'lib_ts/enums/training.enums';
import { IMachine } from 'lib_ts/interfaces/i-machine';
import { useCallback, useEffect } from 'react';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

const SYNC_INTERVAL_MIN = 15;

const useSyncTmsDict = (machine: IMachine) => {
  const onDemand = useFeatureFlag(FF_NAME_ON_DEMAND_MODE);

  const reloadTmsDict = useCallback(
    (silently: boolean) => {
      if (onDemand) {
        // skip when entering OD
        return;
      }

      if (!machine.machineID) {
        // skip the call when there's no machineID
        return;
      }

      if (!machine.ball_type) {
        // skip the call when there's no ball_type
        return;
      }

      useTrainedMsStore
        .getState()
        .buildTmsDict(
          machine.machineID,
          machine.ball_type,
          machine.last_hardware_changed,
          silently
        );
    },
    [
      onDemand, // we don't need TMS stuff while using OD
      machine.machineID,
      machine.ball_type,
      machine.last_hardware_changed,
    ]
  );

  // update silently every X min to keep TMS dict up to date (for long-lived sessions that become active)
  useEffect(() => {
    const interval = setInterval(
      () => {
        reloadTmsDict(true);
      },
      SYNC_INTERVAL_MIN * 60 * 1_000
    );

    return () => {
      clearInterval(interval);
    };
  }, [reloadTmsDict]);

  // setup the tms dict
  useEffect(() => {
    reloadTmsDict(false);
  }, [reloadTmsDict]);
};

export default useSyncTmsDict;
